import { Loading } from "gsintegrations";
import React, { Suspense } from "react";

/**
 * Route-level boundary for lazy pages. Router navigations run as transitions,
 * which keep the previous page (and its route-driven UI such as the form chat)
 * on screen while a lazy chunk loads unless the new route has its own boundary.
 */
export const withRouteSuspense = (children: React.ReactNode) => (
  <Suspense fallback={<Loading />}>{children}</Suspense>
);
